import {Report} from '../models';
import {BaseBlock} from '../components/blocks';

export const toReportEntity = (report: Report, blocks: Partial<BaseBlock>[] | null): Partial<Report> => {
  /*
   * Only update essentials
   */
  const {
    options_json,
    uid,
    /*
     * cleanup what's not needed
     */
    id,
    webhook,
    folder,
    created_by_fk,
    ...report_
  } = report;

  const blockIds: any = blocks
    ?.filter((block: Partial<BaseBlock>) => block.block_id !== undefined)
    .map((block: Partial<BaseBlock>) => block.block_id);

  return {
    name: report.name,
    blocks: blockIds,
    options: JSON.stringify(options_json),
    created_by_fk, // owner
    // folder_id: folder?.id || null,
  };
};
